import { IClassname } from '@/lib/shared/model/classname';

export const Blender = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5249 27.7887C22.5794 27.979 22.5888 28.1793 22.5527 28.3739C22.5165 28.5684 22.4356 28.7519 22.3164 28.9098C22.1973 29.0678 22.043 29.196 21.8658 29.2841C21.6887 29.3723 21.4934 29.4182 21.2956 29.4181H6.79889C6.601 29.4182 6.4058 29.3723 6.22864 29.2841C6.0515 29.196 5.89725 29.0678 5.77806 28.9098C5.65887 28.7519 5.578 28.5684 5.54181 28.3739C5.50562 28.1793 5.51512 27.979 5.56953 27.7887L7.39567 21.3991C7.472 21.1323 7.63312 20.8976 7.85469 20.7304C8.07625 20.5633 8.34621 20.4728 8.62375 20.4727H19.4758C19.7534 20.4728 20.0233 20.5633 20.2449 20.7304C20.4665 20.8976 20.6276 21.1323 20.7039 21.3991L22.5249 27.7887Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8784 29.418V30.6959"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2109 29.418V30.6959"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7793 4.71447C22.9155 4.98752 22.9495 5.30029 22.8752 5.59623L19.1564 20.4725H8.9331L5.21436 5.59623C5.14041 5.30014 5.17486 4.98737 5.31148 4.71447L6.66352 2.0104C6.76957 1.79816 6.93262 1.61964 7.1344 1.49483C7.33617 1.37001 7.56872 1.30384 7.80597 1.30371H20.2836C20.5209 1.30384 20.7533 1.37001 20.9551 1.49483C21.1569 1.61964 21.3199 1.79816 21.426 2.0104L22.7793 4.71447Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9047 5.1377H5.18506"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3513 7.69336H24.2682C24.946 7.69336 25.5961 7.96263 26.0754 8.44195C26.5548 8.92126 26.824 9.57135 26.824 10.2492V15.9998"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0448 26.8625C14.7506 26.8625 15.3227 26.2903 15.3227 25.5846C15.3227 24.8788 14.7506 24.3066 14.0448 24.3066C13.339 24.3066 12.7668 24.8788 12.7668 25.5846C12.7668 26.2903 13.339 26.8625 14.0448 26.8625Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.489 20.4728V11.5273"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6006 20.4728V11.5273"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2111 23.6673C10.0346 23.6673 9.8916 23.5243 9.8916 23.3478C9.8916 23.1713 10.0346 23.0283 10.2111 23.0283"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M10.2109 23.6673C10.3874 23.6673 10.5304 23.5243 10.5304 23.3478C10.5304 23.1713 10.3874 23.0283 10.2109 23.0283"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M17.8786 23.6673C17.7021 23.6673 17.5591 23.5243 17.5591 23.3478C17.5591 23.1713 17.7021 23.0283 17.8786 23.0283"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M17.8787 23.6673C18.0551 23.6673 18.1981 23.5243 18.1981 23.3478C18.1981 23.1713 18.0551 23.0283 17.8787 23.0283"
        stroke="#22364A"
        strokeWidth="1.33"
      />
    </svg>
  );
};
